import { InputProps } from 'antd/lib/input';
import { GroupProps } from 'antd/lib/input/Group';
import { PasswordProps } from 'antd/lib/input/Password';
import { SearchProps } from 'antd/lib/input/Search';
import { TextAreaProps } from 'antd/lib/input/TextArea';
import { Input } from 'antd';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import './VtxInput.scss';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';

export interface VtxInputProps extends InputProps, IAutomatable {}
export interface VtxInputGroupProps extends GroupProps, IAutomatable {}
export interface VtxInputPasswordProps extends PasswordProps, IAutomatable {}
export interface VtxInputSearchProps extends SearchProps, IAutomatable {}
export interface VtxInputTextAreaProps extends TextAreaProps, IAutomatable {}

export const VtxInput: FunctionComponent<VtxInputProps> = React.memo((props: VtxInputProps) => {
    const automationClass = 'vtx-input';
    const { className, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(automationClass, className);

    return (
        <Input data-automation-class={automationClass} className={classNamesCombined} {...otherProps}>
            {props.children}
        </Input>
    );
});

export const VtxInputSearch: FunctionComponent<VtxInputSearchProps> = React.memo(
    (props: VtxInputSearchProps) => {
        const automationClass = 'vtx-input-search';
        const { className, ...otherProps } = preventDataAutomationOverriding(props);
        let defaultPlaceholder = props.placeholder;
        if (defaultPlaceholder === undefined) {
            defaultPlaceholder = 'Search...';
        }
        const classNamesCombined = classNames(automationClass, className);

        return (
            <Input.Search
                data-automation-class={automationClass}
                className={classNamesCombined}
                {...otherProps}
                placeholder={defaultPlaceholder}
            >
                {props.children}
            </Input.Search>
        );
    }
);

export const VtxInputPassword: FunctionComponent<VtxInputPasswordProps> = React.memo(
    (props: VtxInputPasswordProps) => {
        const automationClass = 'vtx-input-password';
        const { className, ...otherProps } = preventDataAutomationOverriding(props);
        const classNamesCombined = classNames(automationClass, className);

        let defaultPlaceholder = props.placeholder;
        if (defaultPlaceholder === undefined) {
            defaultPlaceholder = 'Input password';
        }

        return (
            <Input.Password
                data-automation-class={automationClass}
                className={classNamesCombined}
                placeholder={defaultPlaceholder}
                {...otherProps}
            >
                {props.children}
            </Input.Password>
        );
    }
);

export const VtxInputGroup: FunctionComponent<VtxInputGroupProps> = React.memo(
    (props: VtxInputGroupProps) => {
        const automationClass = 'vtx-input-group';

        const { className, ...otherProps } = preventDataAutomationOverriding(props);
        const classNamesCombined = classNames(automationClass, className);

        return (
            <div data-automation-class={automationClass} className={classNamesCombined}>
                <Input.Group {...otherProps}>{props.children}</Input.Group>
            </div>
        );
    }
);

export const VtxInputTextArea: FunctionComponent<VtxInputTextAreaProps> = React.memo(
    (props: VtxInputTextAreaProps) => {
        const automationClass = 'vtx-input-text-area';

        const { className, ...otherProps } = preventDataAutomationOverriding(props);
        const classNamesCombined = classNames(automationClass, className);

        return (
            <Input.TextArea
                data-automation-class={automationClass}
                className={classNamesCombined}
                {...otherProps}
            >
                {props.children}
            </Input.TextArea>
        );
    }
);
